export default __webpack_public_path__ + "4f54d09553b37a355705b5261195e2fe.jpg";